import { FSA } from 'flux-standard-action';
import { assign as _assign } from 'lodash';
import { stringify, parse } from 'qs';
import { 
  ADD_PARAM,
  CHANGE_PARAMS,
  CLEAR_PARAMS,
  REMOVE_PARAM,
  QueryParamArgument, 
  QueryParemeterPayload, 
  QueryParamType,
  ADD_FILTER_PARAM
} from './query-parameter.action';

export interface QueryParameterState {
  params: QueryParemeterPayload;
  search?: string;
}

export const queryParameterInitialState: QueryParameterState = {
  params: {
    list: 1,
    sword: undefined,
    filter: undefined,
    tab: 'mine',
    groupKey: 'de',
    folderId: undefined,
		// password reset stuff
		uuid: undefined,
		token: undefined,
		hash: undefined
  },
  search: undefined,
};

export const queryParameterReducer = (
  state: QueryParameterState = queryParameterInitialState, 
  action: FSA<string, QueryParamArgument | QueryParemeterPayload>
) => {
  const filter = _assign({}, state.params && state.params.filter, action.payload);
  //console.log('query reducer', filter);
  // ?from= doesnt get read properly, might want to add it otherwise things like this - filterComparativeParameter(parse(search), Object.keys(queryParameterInitialState.params)) - fails
  
  switch (action.type) {
    case ADD_FILTER_PARAM:   
      return _assign(
        {},
        state, {
          params: {
            //sword: state.params && state.params.sword,
            filter: filter
          },
          search: `?${stringify(filter)}`,
        },  
      );

    case ADD_PARAM:
      const newAddParams = action.payload && addParam(state.params, action.payload as QueryParamArgument);
      return _assign(
        {}, 
        state, {
          params: newAddParams && transformBoolean(newAddParams),
          search: `?${stringify(newAddParams)}`,
        },
      );
    
    case CHANGE_PARAMS:
      const newChanegParams = action.payload as QueryParemeterPayload;
      return action.payload && _assign(
        {}, 
        state, {
          params: transformBoolean((action.payload as QueryParemeterPayload)),
          search: `?${stringify(newChanegParams)}`,
        }
      ) || state;
    
    case CLEAR_PARAMS: 
      return JSON.parse(JSON.stringify(queryParameterInitialState))
    
    case REMOVE_PARAM:
      const type = action.payload && (action.payload as {type: QueryParamType}).type as string;
      const removeParams = type && _assign({}, state.params, {
        [type]: undefined,
      });
      return _assign({}, state, {
        params: removeParams,
        search: removeParams && Object.keys(removeParams).length > 0 && `?${stringify(removeParams)}` || ''
      }) || state;
    
    default:
      return state;
  }
};

const transformBoolean = (params: QueryParemeterPayload): QueryParemeterPayload => {
  const newParams = params;
  if (newParams.filter) {
    const filterKeys = Object.keys(newParams.filter);
    filterKeys.map(key => {
      if (newParams.filter) {
        newParams.filter[key] = (newParams.filter[key] === 'true') ? true : (newParams.filter[key] === 'false') ? false : undefined;
        if (newParams.filter[key] === undefined) {
          delete newParams.filter[key];
        }
      }
    });
  }
  return newParams;
};

const addParam = (params: QueryParemeterPayload, payload: QueryParamArgument): QueryParemeterPayload => {
  const newParams = params;
  newParams[payload.type] = payload.type === 'filter' ? parse(payload.param as string) : payload.param;
  return newParams;
};